import { fetchApi } from "../utils/fetchApi";

export function fetchSmartmeter({ filter = {}, options = {} }) {
  return fetchApi({ url: 'smartmeter', filter, options });
}